import Special_69 from "./special/present_69/main";

//specialページ汎用
const special = new Special_69();